import type { FullAuditProgress } from "../auditLaunch/guardiansAuditLaunchStore";

/** In-flight investigate audit queued from one alert's detail panel. */

export interface PendingAlertAudit {
  auditId: string;
  taskId: string;
}

export type PendingAlertAuditMap = Record<string, PendingAlertAudit>;

export function pendingAuditForAlert(
  map: PendingAlertAuditMap,
  alertId: string | null | undefined
): PendingAlertAudit | undefined {
  if (!alertId) return undefined;
  return map[alertId];
}

/** True while the runner task is in flight (or not yet visible in the launch store). */
export function isPendingAuditTaskActive(
  progress: FullAuditProgress
): boolean {
  if (progress.active) return true;
  return progress.total === 0 && progress.finished === 0;
}

/** Drop map entries whose runner tasks have finished. Returns task ids to dismiss. */
export function pruneCompletedPendingAudits(
  map: PendingAlertAuditMap,
  progressForTask: (taskId: string) => FullAuditProgress
): { next: PendingAlertAuditMap; completedTaskIds: string[] } {
  const completedTaskIds: string[] = [];
  let changed = false;
  const next: PendingAlertAuditMap = {};

  for (const [alertId, pending] of Object.entries(map)) {
    if (isPendingAuditTaskActive(progressForTask(pending.taskId))) {
      next[alertId] = pending;
    } else {
      completedTaskIds.push(pending.taskId);
      changed = true;
    }
  }

  return { next: changed ? next : map, completedTaskIds };
}
